import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { AlertModule, MessageModule } from '@app/common';
import { Services } from '@app/shared/services';
import { AppStorage } from '@app/shared/services/cookies/app-storage';
import { CookieStorage } from '@app/shared/services/cookies/cookie.storage';
import { SharedModule } from '@app/shared/shared.module';
import { environment } from '@env/environment';
import { NgbActiveModal, NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { PdfViewerModule } from 'ng2-pdf-viewer';
// Cookie Consent
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { ImgFallbackModule } from 'ngx-img-fallback';
import { MomentModule } from 'ngx-moment';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader';
import { CookieConfig } from '../app/common/cookieConsent';
import { BsFileUploadNewComponent } from './modules/bs-file-upload-new/bs-file-upload-new.component';
import { ProfileStepperBarSuccessComponent } from './modules/profile-stepper-bar-success/profile-stepper-bar-success.component';
import { InviteUserCreateRelationshipComponent } from './modules/relationship/components/dialogs/invite-user-create-relationship/invite-user-create-relationship.component';
//  NGRX Store
import { RootStoreModule } from './root-store/root-store.module';
import { CommonUploadDialogComponent } from './shared/component/common-upload-dialog/common-upload-dialog.component';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { AddAssigneeDialogComponent } from './modules/vault/components/dialogs/add-assignee-dialog/add-assignee-dialog.component';
import { ManageMxTaskbarComponent } from './shared/component/manage-mx-taskbar/manage-mx-taskbar.component';
import { AvatarModule } from 'ngx-avatars';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { OnBoardingModule } from './modules/on-boarding/on-boarding.module';
class MyErrorHandler implements ErrorHandler {
  handleError(error) {
    // do something with the exception
  }
}
@NgModule({ bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        ProfileStepperBarSuccessComponent,
        InviteUserCreateRelationshipComponent,
        ProfileStepperBarSuccessComponent,
        BsFileUploadNewComponent,
        // CommonUploadDialogComponent,
        AddAssigneeDialogComponent,
        ManageMxTaskbarComponent,
    ], imports: [PdfViewerModule,
        AppRoutingModule,
        BrowserModule,
        NgxUiLoaderModule,
        BrowserAnimationsModule,
        ImgFallbackModule,
        AlertModule,
        MessageModule,
        SharedModule.forRoot(),
        MomentModule.forRoot(),
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-bottom-left',
            preventDuplicates: true,
        }),
        RootStoreModule,
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production, connectInZone: true }),
        CarouselModule,
        NgcCookieConsentModule.forRoot(CookieConfig),
        CommonModule,
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
        CommonUploadDialogComponent,
        RecaptchaModule,
        RecaptchaFormsModule,
        // SharedModule,
        // MomentModule,
        NgbModule,
        NgbCarouselModule,
        // CarouselModule,
        AvatarModule,
        InfiniteScrollModule,
        OnBoardingModule], providers: [
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha_siteKey,
        },
        NgxUiLoaderService,
        NgbActiveModal,
        { provide: ErrorHandler, useClass: MyErrorHandler },
        { provide: AppStorage, useClass: CookieStorage },
        ...Services,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
